import React, { Component } from "react";

import { CCard, CCol, CLink, CPagination, CRow } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { setObj } from "../../../actions/noteActions";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import { formatDate, baseDate } from "../../../utils/date";
import CorrectLiterarte from "../../CorrectLiterarte";
import LiterarteModal from "../../LiterarteModal";
import Loading from "../../Loading";
import SelectUserLiterarteModal from "../../SelectUserLiterarteModal";

class LiterarteActivities extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      activities: [],
      textProduction: {
        id: "",
        show: false,
        value: [
          {
            type: "paragraph",
            children: [{ text: "" }]
          }
        ]
      },
      activity_id: null,
      id: null,
      user_id: null,
      allocation_id: null,
      item_id: null,
      execution_id: null,
      correctLiterarteModal: false,
      late: false,
      maxItems: 12,
      currentPage: 1
    };
  }

  componentDidMount() {
    this.handleActivities();
  }

  handleActivities(showLoading = true) {
    if (showLoading) {
      this.setState({ loading: true });
    }

    axios
      .get(`${URL.api}literarte/activity/list`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.setState({ loading: false, activities: resp.data.data });
          } else {
            toastr.error(
              "Falha",
              "Não foi possível obter as atividades do Literarte"
            );
            this.setState({ loading: false });
          }
        },
        err => {
          toastr.error(
            "Falha",
            "Não foi possível obter as atividades do Literarte"
          );
          this.setState({ loading: false });
        }
      );
  }

  saveTextProduction = pages => {
    let pagesObj = [];
    for (let i = 0; i < pages.length; i++) {
      pagesObj.push({
        number: i,
        content: JSON.stringify(pages[i])
      });
    }

    let obj = {
      user_id: this.props.user.user.id,
      literarte_activity_id: this.state.textProduction.id,
      pages: pagesObj,
      item_id: this.state.item_id,
      execution_id: this.state.execution_id,
      start: baseDate(this.state.literarteStart),
      end: baseDate(new Date())
    };

    axios
      .post(`${URL.api}literarte/production_create`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            toastr.success("Sucesso", "O texto foi salvo.");
            this.setState(
              state => ({
                textProduction: {
                  ...state.textProduction,
                  show: false
                }
              }),
              () => this.handleActivities(false)
            );
          } else {
            toastr.error("Falha", "Não foi possível salvar o texto.");
          }
        },
        error => {
          toastr.error("Falha", "Não foi possível salvar o texto.");
        }
      );
  };

  openActivity(e, activity) {
    e.preventDefault();

    if (activity.allocations.length === 0) {
      toastr.warning("Atenção", "A atividade ainda não foi alocada");
    } else if (activity.user_id === this.props.user.user.id) {
      this.setState({
        selectUserModal: true,
        activity_id: activity.activity_id,
        id: activity.id,
        item_id: activity.item_id,
        allocation_id: activity.allocations[0].id,
        late: false
      });
      // } else if (activity.final_grade) {
      //   toastr.info(
      //     "Item realizado",
      //     `Você tirou a nota ${activity.final_grade}`
      //   );
    } else {
      if (
        new Date() > new Date(activity.allocations[0].end) &&
        !activity.execution_item_id
      ) {
        toastr.warning("Atenção", "A atividade já expirou");
        return;
      }

      this.setState(state => ({
        textProduction: {
          ...state.textProduction,
          show: true,
          id: activity.id
        },
        execution_id: activity.execution_id,
        item_id: activity.item_id,
        contentName: activity.title,
        literarteStart: new Date(),
        late: new Date() > new Date(activity.allocations[0].end)
      }));

      if (!activity.execution_id) {
        const obj = {
          allocation_id: activity.allocations[0].id
        };

        axios
          .post(`${URL.api}activity/execution/insertByAllocation`, obj, {
            headers: {
              authorization: `Bearer ${this.props.user.token}`,
              "Access-Control-Allow-Origin": "*"
            }
          })
          .then(resp => {
            if (resp.data.success) {
              this.setState({ execution_id: resp.data.data });
            } else {
              toastr.error("Falha", "Falha ao criar a execução da atividade!");
            }
          })
          .catch(error => {
            toastr.error("Falha", "Falha ao criar a execução da atividade!");
          });
      }
    }
  }

  openCorrection(obj) {
    if (!obj) {
      this.setState({
        selectUserModal: false
      });

      return;
    }

    this.setState({
      execution_id: obj.execution_id,
      user_id: obj.user_id,
      selectUserModal: false,
      correctLiterarteModal: true
    });
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="w-100 d-flex p-4 justify-content-center align-items-center">
          <Loading />
        </div>
      );
    }

    const searchedActivities = this.state.activities.filter(
      activity =>
        !this.props.search ||
        activity.title.toLowerCase().includes(this.props.search.toLowerCase())
    );

    if (searchedActivities.length === 0) {
      return (
        <div className="w-100 d-flex p-4 justify-content-center align-items-center text-muted">
          Nenhuma atividade encontrada
        </div>
      );
    }

    return (
      <>
        <CRow>
          {searchedActivities
            .slice(
              (this.state.currentPage - 1) * this.state.maxItems,
              this.state.currentPage * this.state.maxItems
            )
            .map(activity => (
              <CCol xs="12" sm="6" md="4" xl="3" key={activity.id}>
                <CCard style={{ borderBottom: "3px solid var(--purple)" }}>
                  <div className="card-body">
                    <h5 className="card-title font-weight-semibold mb-0 text-ellipsis">
                      <CLink
                        to="#"
                        className="text-black"
                        onClick={e => this.openActivity(e, activity)}
                      >
                        {activity.title}
                      </CLink>
                    </h5>
                    <p className="card-text mb-3 text-ellipsis">
                      <small className="text-muted">
                        {activity.allocations.length > 0 ? (
                          <>
                            Em{" "}
                            <CLink
                              to={`/activity/do/${activity.allocations[0].id}`}
                              target="_blank"
                            >
                              {activity.activity_name}
                            </CLink>
                          </>
                        ) : (
                          <>Não alocado</>
                        )}
                      </small>
                    </p>
                    <p className="card-text mb-0 text-ellipsis">
                      {activity.type_name}
                    </p>
                    <div className="d-flex my-2">
                      <div
                        className="ml-3 mr-2 bg-light"
                        style={{ width: "1px" }}
                      ></div>
                      <div className="flex-1 text-muted small">
                        <div>
                          De{" "}
                          {activity.allocations.length > 0
                            ? formatDate(activity.allocations[0].start)
                            : "-"}
                        </div>
                        <div>
                          Até{" "}
                          {activity.allocations.length > 0
                            ? formatDate(activity.allocations[0].end)
                            : "-"}
                        </div>
                      </div>
                    </div>
                    <p className="card-text mb-0 mt-3">
                      {activity.user_id === this.props.user.user.id ? (
                        <small className="text-primary">
                          <i className="fa fa-user-circle mr-1"></i>Criado por
                          mim
                        </small>
                      ) : activity.final_grade ? (
                        <small className="text-success">
                          <i className="fa fa-check-circle mr-1"></i>Corrigido (
                          {activity.final_grade})
                        </small>
                      ) : activity.execution_item_id ? (
                        <small className="text-warning">
                          <i className="fa fa-exclamation-circle mr-1"></i>Não
                          corrigido
                        </small>
                      ) : new Date() > new Date(activity.allocations[0].end) ? (
                        <small className="text-danger">
                          <i className="fa fa-times-circle mr-1"></i>Atrasado
                        </small>
                      ) : (
                        <small className="text-primary">
                          <i className="fa fa-info-circle  mr-1"></i>A fazer
                        </small>
                      )}
                    </p>
                  </div>
                </CCard>
              </CCol>
            ))}
        </CRow>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
          className="mb-3"
        >
          <div>
            <span>Total de atividades: {searchedActivities?.length || 0}</span>
          </div>
          <CPagination
            className="m-0"
            addListClass="m-0"
            activePage={this.state.currentPage}
            pages={
              Math.ceil(searchedActivities.length / this.state.maxItems) || 1
            }
            onActivePageChange={page => this.setState({ currentPage: page })}
            color="secondary"
          />
        </div>
        {this.state.textProduction.show ? (
          <LiterarteModal
            id={this.state.textProduction.id}
            user_id={this.props.user.user.id}
            show={this.state.textProduction.show}
            onClose={() =>
              this.setState(
                state => ({
                  textProduction: {
                    ...state.textProduction,
                    show: false
                  }
                }),
                () => this.handleActivities(false)
              )
            }
            title={this.state.contentName}
            value={this.state.textProduction.value}
            onChange={value =>
              this.setState(state => ({
                textProduction: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  ...this.state.textProduction,
                  value
                }
              }))
            }
            saveTextProduction={pages => this.saveTextProduction(pages)}
            late={this.state.late}
          />
        ) : null}
        {this.state.selectUserModal && (
          <SelectUserLiterarteModal
            show
            allocation_id={this.state.allocation_id}
            item_id={this.state.item_id}
            onClose={obj => this.openCorrection(obj)}
          />
        )}
        {this.state.correctLiterarteModal && (
          <CorrectLiterarte
            show
            onClose={() =>
              this.setState({ correctLiterarteModal: false }, () =>
                this.handleActivities(false)
              )
            }
            activityId={this.state.activity_id}
            currentRoute={this.props.currentRoute}
            allocation_id={this.state.allocation_id}
            id={this.state.id}
            history={this.props.history}
            item_id={this.state.item_id}
            execution_id={this.state.execution_id}
            user_id={this.state.user_id}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiterarteActivities);
